// dynamic-host.directive.ts
import { Directive, Input, ViewContainerRef, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDynamicHost]'
})
export class DynamicHostDirective {
  @Input('appDynamicHost') hostId: string;

  constructor(
    public viewContainerRef: ViewContainerRef,
    public elementRef: ElementRef<HTMLElement>
  ) { }
}
